import { render } from "./PDFViewer.vue?vue&type=template&id=01517339&scoped=true"
import script from "./PDFViewer.vue?vue&type=script&lang=js"
export * from "./PDFViewer.vue?vue&type=script&lang=js"

import "./PDFViewer.vue?vue&type=style&index=0&id=01517339&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01517339"]])

export default __exports__